if (!customElements.get('anniversary-hero')) {
  customElements.define(
    'anniversary-hero',
    class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return
        this.abort = new AbortController()
        const link = this.querySelector('[data-explore]')
        if (!link || link.getAttribute('href')) return
        let target = this.closest('.shopify-section')?.nextElementSibling
        while (target && (target.hidden || !target.getBoundingClientRect().height))
          target = target.nextElementSibling
        if (!target?.id) return
        link.setAttribute('href', `#${target.id}`)
        this.generatedLink = link
        link.addEventListener(
          'click',
          (event) => {
            event.preventDefault()
            target.scrollIntoView({
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            })
          },
          { signal: this.abort.signal },
        )
      }

      disconnectedCallback() {
        this.abort?.abort()
        this.abort = null
        this.generatedLink?.removeAttribute('href')
        this.generatedLink = null
      }
    },
  )
}
